import React from "react";
import { Projects } from "../commons/resume";
import projects from "./projects";

const ProjectsSection = () => {
  return (
    <div>
      {projects.map((project, index) => (
        <Projects
          key={index}
          image={project.image}
          title={project.title}
          link={project.link}
          description={project.description}
        />
      ))}
    </div>
  );
};

export default ProjectsSection;
